// PROMPT 17 — Dynamic progress + Edit + Save planning (5 languages)
export const extra14 = {
  pt: {
    "plan.del_b5": "Seus salvamentos de Decoração, Ceia, Mesa e Presentes e o orçamento serão apagados",
    "plan.planned_title": "✨ Seu Natal está planejado!",
    "plan.edit": "Editar Planejamento",
    "plan.edit_short": "Editar",
    "plan.save": "Salvar Meu Planejamento",
    "plan.saving": "Salvando…",
    "plan.save_and_exit": "Salvar e sair",
    "plan.discard": "Descartar alterações",
    "plan.keep_editing": "Continuar editando",
    "plan.unsaved_title": "Alterações não salvas",
    "plan.unsaved_body": "Você fez alterações no seu planejamento que ainda não foram salvas. O que deseja fazer?",
    "plan.editor_title": "Editar Planejamento",
    "plan.editor_sub": "Toque em uma etapa para concluí-la. Salve para atualizar o seu progresso.",
    "plan.provisional": "Progresso provisório",
    "plan.last_update": "Última atualização: {when}",
    "plan.not_saved_yet": "Você ainda não salvou seu planejamento.",
    "plan.open": "Abrir",
    "plan.steps_done": "{done} de {total} etapas concluídas",
    "plan.saved_toast": "Planejamento salvo!",
    "plan.done": "Concluída",
    "plan.todo": "A fazer",
    "plan.na_mark": "Não se aplica",
    "plan.na_applicable": "Marcar como aplicável",
    "plan.na_tag": "Não se aplica",
    "cbud.title": "Orçamento desta categoria",
    "cbud.sub": "Valor reservado para esta categoria, definido no seu orçamento inicial. Para mudar, edite em Meu Orçamento.",
    "cbud.save": "Salvar orçamento",
    "review.yes": "Sim",
    "review.no": "Não",
    "review.ask_body": "Seu orçamento para {cat} é {old}. Você está tentando alterar para {new} — isso representa {delta} a mais. Para manter seu orçamento total do Natal, precisamos retirar {delta} de outra categoria. O que você deseja fazer?",
    "review.act_redistribute": "Redistribuir {v}",
    "review.act_increase": "Aumentar meu orçamento",
    "review.act_cancel": "Cancelar",
    "review.q2_title": "Quer rever seu orçamento?",
    "review.q2_body": "Você decidiu não retirar {delta} de outra categoria. Seu orçamento de {cat} continua em {old}. Se quiser gastar mais nesta categoria, você pode aumentar o orçamento total do seu Natal. Deseja rever seu orçamento total?",
    "review.keep": "Não, manter meu plano",
    "review.review": "Sim, rever meu orçamento",
    "review.total_body": "Você tentou aumentar {cat} de {old} para {new}. Para fazer isso sem reduzir outras categorias, seu orçamento total precisará aumentar em {inc}.",
    "review.current": "Orçamento atual",
    "review.suggested": "Sugestão de novo orçamento",
    "review.new_total_label": "Novo orçamento total",
    "review.min_hint": "O novo total precisa ser ao menos {v}.",
    "review.cancel": "Cancelar",
    "review.confirm_total": "Confirmar novo orçamento",
    "review.total_saved": "Orçamento total atualizado",
    "review.apply_body": "Agora que seu orçamento foi atualizado, deseja reservar {new} para {cat}?",
    "review.apply_yes": "Sim, aplicar",
    "review.apply_no": "Não",
    "ss.delete_group": "Excluir grupo",
    "ss.delete_group_q": "Excluir este grupo de Amigo Oculto?",
    "ss.delete_group_note": "Isso removerá o grupo, os participantes, o sorteio e as listas de desejos. Esta ação não pode ser desfeita.",
    "ss.delete_group_yes": "Sim, excluir grupo",
    "ss.deleted": "Grupo excluído",
    "plan.delete": "Excluir planejamento",
    "plan.del_title": "Excluir seu planejamento?",
    "plan.del_body": "Isso apagará o planejamento atual do seu Natal e permitirá que você comece novamente do zero.",
    "plan.del_b1": "Seu progresso voltará para 0%",
    "plan.del_b2": "As etapas concluídas serão zeradas",
    "plan.del_b3": "As configurações atuais do planejamento serão removidas",
    "plan.del_b4": "Você poderá criar um novo planejamento em seguida",
    "plan.del_sure": "Tem certeza de que deseja excluir este planejamento?",
    "plan.del_note_account": "Isso não cancela sua conta, seu acesso nem sua compra.",
    "plan.del_ss_note": "Seus grupos de Amigo Oculto (com participantes ou sorteios) serão preservados.",
    "plan.del_cancel": "Cancelar",
    "plan.del_confirm": "Sim, excluir e começar novamente",
    "plan.del_deleting": "Excluindo…",
    "plan.del_ok_title": "Planejamento excluído",
    "plan.del_ok_body": "Você pode começar um novo Natal quando quiser. 🎄",
    "plan.del_ok_cta": "Criar meu Natal",
    "plan.del_err_title": "Não foi possível excluir",
    "plan.del_err_body": "Não foi possível excluir seu planejamento. Tente novamente.",
    "plan.del_retry": "Tentar novamente",
  },
  en: {
    "plan.del_b5": "Your saved Decoration, Dinner, Table and Gift versions and the budget will be deleted",
    "plan.planned_title": "✨ Your Christmas is planned!",
    "plan.edit": "Edit planning",
    "plan.edit_short": "Edit",
    "plan.save": "Save my planning",
    "plan.saving": "Saving…",
    "plan.save_and_exit": "Save and exit",
    "plan.discard": "Discard changes",
    "plan.keep_editing": "Keep editing",
    "plan.unsaved_title": "Unsaved changes",
    "plan.unsaved_body": "You made changes to your planning that haven't been saved yet. What would you like to do?",
    "plan.editor_title": "Edit planning",
    "plan.editor_sub": "Tap a step to complete it. Save to update your progress.",
    "plan.provisional": "Provisional progress",
    "plan.last_update": "Last updated: {when}",
    "plan.not_saved_yet": "You haven't saved your planning yet.",
    "plan.open": "Open",
    "plan.steps_done": "{done} of {total} steps done",
    "plan.saved_toast": "Planning saved!",
    "plan.done": "Done",
    "plan.todo": "To do",
    "plan.na_mark": "Not applicable",
    "plan.na_applicable": "Mark as applicable",
    "plan.na_tag": "N/A",
    "cbud.title": "Budget for this category",
    "cbud.sub": "Amount reserved for this category, set in your initial budget. To change it, edit it in My Budget.",
    "cbud.save": "Save budget",
    "review.yes": "Yes",
    "review.no": "No",
    "review.ask_body": "Your budget for {cat} is {old}. You're trying to change it to {new} — that's {delta} more. To keep your total Christmas budget, we need to take {delta} from another category. What would you like to do?",
    "review.act_redistribute": "Redistribute {v}",
    "review.act_increase": "Increase my budget",
    "review.act_cancel": "Cancel",
    "review.q2_title": "Want to review your budget?",
    "review.q2_body": "You chose not to take {delta} from another category. Your {cat} budget stays at {old}. If you'd like to spend more here, you can raise your total Christmas budget. Do you want to review your total budget?",
    "review.keep": "No, keep my plan",
    "review.review": "Yes, review my budget",
    "review.total_body": "You tried to raise {cat} from {old} to {new}. To do that without reducing other categories, your total budget needs to increase by {inc}.",
    "review.current": "Current budget",
    "review.suggested": "Suggested new budget",
    "review.new_total_label": "New total budget",
    "review.min_hint": "The new total must be at least {v}.",
    "review.cancel": "Cancel",
    "review.confirm_total": "Confirm new budget",
    "review.total_saved": "Total budget updated",
    "review.apply_body": "Now that your budget is updated, do you want to reserve {new} for {cat}?",
    "review.apply_yes": "Yes, apply",
    "review.apply_no": "No",
    "ss.delete_group": "Delete group",
    "ss.delete_group_q": "Delete this Secret Santa group?",
    "ss.delete_group_note": "This will remove the group, participants, the draw and wishlists. This action cannot be undone.",
    "ss.delete_group_yes": "Yes, delete group",
    "ss.deleted": "Group deleted",
    "plan.delete": "Delete planning",
    "plan.del_title": "Delete your planning?",
    "plan.del_body": "This will erase your current Christmas planning and let you start over from scratch.",
    "plan.del_b1": "Your progress will go back to 0%",
    "plan.del_b2": "Completed steps will be reset",
    "plan.del_b3": "Your current planning settings will be removed",
    "plan.del_b4": "You'll be able to create a new plan right after",
    "plan.del_sure": "Are you sure you want to delete this planning?",
    "plan.del_note_account": "This does not cancel your account, access or purchase.",
    "plan.del_ss_note": "Your Secret Santa groups (with participants or draws) will be preserved.",
    "plan.del_cancel": "Cancel",
    "plan.del_confirm": "Yes, delete and start over",
    "plan.del_deleting": "Deleting…",
    "plan.del_ok_title": "Planning deleted",
    "plan.del_ok_body": "You can start a new Christmas whenever you like. 🎄",
    "plan.del_ok_cta": "Create my Christmas",
    "plan.del_err_title": "Couldn't delete",
    "plan.del_err_body": "We couldn't delete your planning. Please try again.",
    "plan.del_retry": "Try again",
  },
  es: {
    "plan.del_b5": "Tus guardados de Decoración, Cena, Mesa y Regalos y el presupuesto se borrarán",
    "plan.planned_title": "✨ ¡Tu Navidad está planificada!",
    "plan.edit": "Editar planificación",
    "plan.edit_short": "Editar",
    "plan.save": "Guardar mi planificación",
    "plan.saving": "Guardando…",
    "plan.save_and_exit": "Guardar y salir",
    "plan.discard": "Descartar cambios",
    "plan.keep_editing": "Seguir editando",
    "plan.unsaved_title": "Cambios sin guardar",
    "plan.unsaved_body": "Hiciste cambios en tu planificación que aún no se han guardado. ¿Qué deseas hacer?",
    "plan.editor_title": "Editar planificación",
    "plan.editor_sub": "Toca una etapa para completarla. Guarda para actualizar tu progreso.",
    "plan.provisional": "Progreso provisional",
    "plan.last_update": "Última actualización: {when}",
    "plan.not_saved_yet": "Aún no has guardado tu planificación.",
    "plan.open": "Abrir",
    "plan.steps_done": "{done} de {total} etapas completadas",
    "plan.saved_toast": "¡Planificación guardada!",
    "plan.done": "Completada",
    "plan.todo": "Pendiente",
    "plan.na_mark": "No aplica",
    "plan.na_applicable": "Marcar como aplicable",
    "plan.na_tag": "No aplica",
    "cbud.title": "Presupuesto de esta categoría",
    "cbud.sub": "Importe reservado para esta categoría, definido en tu presupuesto inicial. Para cambiarlo, edítalo en Mi Presupuesto.",
    "cbud.save": "Guardar presupuesto",
    "review.yes": "Sí",
    "review.no": "No",
    "review.ask_body": "Tu presupuesto para {cat} es {old}. Intentas cambiarlo a {new}, es decir {delta} más. Para mantener tu presupuesto total de Navidad, necesitamos quitar {delta} de otra categoría. ¿Qué deseas hacer?",
    "review.act_redistribute": "Redistribuir {v}",
    "review.act_increase": "Aumentar mi presupuesto",
    "review.act_cancel": "Cancelar",
    "review.q2_title": "¿Quieres revisar tu presupuesto?",
    "review.q2_body": "Decidiste no quitar {delta} de otra categoría. Tu presupuesto de {cat} sigue en {old}. Si quieres gastar más aquí, puedes aumentar el presupuesto total de tu Navidad. ¿Deseas revisar tu presupuesto total?",
    "review.keep": "No, mantener mi plan",
    "review.review": "Sí, revisar mi presupuesto",
    "review.total_body": "Intentaste aumentar {cat} de {old} a {new}. Para hacerlo sin reducir otras categorías, tu presupuesto total deberá aumentar en {inc}.",
    "review.current": "Presupuesto actual",
    "review.suggested": "Sugerencia de nuevo presupuesto",
    "review.new_total_label": "Nuevo presupuesto total",
    "review.min_hint": "El nuevo total debe ser al menos {v}.",
    "review.cancel": "Cancelar",
    "review.confirm_total": "Confirmar nuevo presupuesto",
    "review.total_saved": "Presupuesto total actualizado",
    "review.apply_body": "Ahora que tu presupuesto está actualizado, ¿deseas reservar {new} para {cat}?",
    "review.apply_yes": "Sí, aplicar",
    "review.apply_no": "No",
    "ss.delete_group": "Eliminar grupo",
    "ss.delete_group_q": "¿Eliminar este grupo de Amigo Invisible?",
    "ss.delete_group_note": "Esto eliminará el grupo, los participantes, el sorteo y las listas de deseos. Esta acción no se puede deshacer.",
    "ss.delete_group_yes": "Sí, eliminar grupo",
    "ss.deleted": "Grupo eliminado",
    "plan.delete": "Eliminar planificación",
    "plan.del_title": "¿Eliminar tu planificación?",
    "plan.del_body": "Esto borrará la planificación actual de tu Navidad y te permitirá empezar de nuevo desde cero.",
    "plan.del_b1": "Tu progreso volverá al 0%",
    "plan.del_b2": "Las etapas completadas se restablecerán",
    "plan.del_b3": "Se eliminarán los ajustes actuales de la planificación",
    "plan.del_b4": "Podrás crear una nueva planificación enseguida",
    "plan.del_sure": "¿Seguro que deseas eliminar esta planificación?",
    "plan.del_note_account": "Esto no cancela tu cuenta, tu acceso ni tu compra.",
    "plan.del_ss_note": "Tus grupos de Amigo Invisible (con participantes o sorteos) se conservarán.",
    "plan.del_cancel": "Cancelar",
    "plan.del_confirm": "Sí, eliminar y empezar de nuevo",
    "plan.del_deleting": "Eliminando…",
    "plan.del_ok_title": "Planificación eliminada",
    "plan.del_ok_body": "Puedes empezar una nueva Navidad cuando quieras. 🎄",
    "plan.del_ok_cta": "Crear mi Navidad",
    "plan.del_err_title": "No se pudo eliminar",
    "plan.del_err_body": "No pudimos eliminar tu planificación. Inténtalo de nuevo.",
    "plan.del_retry": "Intentar de nuevo",
  },
  fr: {
    "plan.del_b5": "Vos enregistrements Décoration, Repas, Table et Cadeaux et le budget seront supprimés",
    "plan.planned_title": "✨ Votre Noël est planifié !",
    "plan.edit": "Modifier la planification",
    "plan.edit_short": "Modifier",
    "plan.save": "Enregistrer ma planification",
    "plan.saving": "Enregistrement…",
    "plan.save_and_exit": "Enregistrer et quitter",
    "plan.discard": "Annuler les modifications",
    "plan.keep_editing": "Continuer à modifier",
    "plan.unsaved_title": "Modifications non enregistrées",
    "plan.unsaved_body": "Vous avez apporté des modifications à votre planification qui ne sont pas encore enregistrées. Que souhaitez-vous faire ?",
    "plan.editor_title": "Modifier la planification",
    "plan.editor_sub": "Touchez une étape pour la compléter. Enregistrez pour mettre à jour votre progression.",
    "plan.provisional": "Progression provisoire",
    "plan.last_update": "Dernière mise à jour : {when}",
    "plan.not_saved_yet": "Vous n'avez pas encore enregistré votre planification.",
    "plan.open": "Ouvrir",
    "plan.steps_done": "{done} sur {total} étapes terminées",
    "plan.saved_toast": "Planification enregistrée !",
    "plan.done": "Terminée",
    "plan.todo": "À faire",
    "plan.na_mark": "Non applicable",
    "plan.na_applicable": "Marquer comme applicable",
    "plan.na_tag": "N/A",
    "cbud.title": "Budget de cette catégorie",
    "cbud.sub": "Montant réservé pour cette catégorie, défini dans votre budget initial. Pour le modifier, éditez-le dans Mon Budget.",
    "cbud.save": "Enregistrer le budget",
    "review.yes": "Oui",
    "review.no": "Non",
    "review.ask_body": "Votre budget pour {cat} est de {old}. Vous essayez de le changer à {new}, soit {delta} de plus. Pour conserver votre budget total de Noël, nous devons retirer {delta} d'une autre catégorie. Que souhaitez-vous faire ?",
    "review.act_redistribute": "Redistribuer {v}",
    "review.act_increase": "Augmenter mon budget",
    "review.act_cancel": "Annuler",
    "review.q2_title": "Revoir votre budget ?",
    "review.q2_body": "Vous avez choisi de ne pas retirer {delta} d'une autre catégorie. Votre budget {cat} reste à {old}. Si vous souhaitez dépenser plus ici, vous pouvez augmenter le budget total de votre Noël. Voulez-vous revoir votre budget total ?",
    "review.keep": "Non, garder mon plan",
    "review.review": "Oui, revoir mon budget",
    "review.total_body": "Vous avez tenté d'augmenter {cat} de {old} à {new}. Pour cela sans réduire les autres catégories, votre budget total devra augmenter de {inc}.",
    "review.current": "Budget actuel",
    "review.suggested": "Nouveau budget suggéré",
    "review.new_total_label": "Nouveau budget total",
    "review.min_hint": "Le nouveau total doit être d'au moins {v}.",
    "review.cancel": "Annuler",
    "review.confirm_total": "Confirmer le nouveau budget",
    "review.total_saved": "Budget total mis à jour",
    "review.apply_body": "Maintenant que votre budget est mis à jour, voulez-vous réserver {new} pour {cat} ?",
    "review.apply_yes": "Oui, appliquer",
    "review.apply_no": "Non",
    "ss.delete_group": "Supprimer le groupe",
    "ss.delete_group_q": "Supprimer ce groupe de Père Noël secret ?",
    "ss.delete_group_note": "Cela supprimera le groupe, les participants, le tirage et les listes de souhaits. Cette action est irréversible.",
    "ss.delete_group_yes": "Oui, supprimer le groupe",
    "ss.deleted": "Groupe supprimé",
    "plan.delete": "Supprimer la planification",
    "plan.del_title": "Supprimer votre planification ?",
    "plan.del_body": "Cela effacera la planification actuelle de votre Noël et vous permettra de recommencer à zéro.",
    "plan.del_b1": "Votre progression reviendra à 0 %",
    "plan.del_b2": "Les étapes terminées seront réinitialisées",
    "plan.del_b3": "Les réglages actuels de la planification seront supprimés",
    "plan.del_b4": "Vous pourrez créer une nouvelle planification juste après",
    "plan.del_sure": "Êtes-vous sûr de vouloir supprimer cette planification ?",
    "plan.del_note_account": "Cela n'annule ni votre compte, ni votre accès, ni votre achat.",
    "plan.del_ss_note": "Vos groupes de Père Noël secret (avec participants ou tirages) seront conservés.",
    "plan.del_cancel": "Annuler",
    "plan.del_confirm": "Oui, supprimer et recommencer",
    "plan.del_deleting": "Suppression…",
    "plan.del_ok_title": "Planification supprimée",
    "plan.del_ok_body": "Vous pouvez commencer un nouveau Noël quand vous voulez. 🎄",
    "plan.del_ok_cta": "Créer mon Noël",
    "plan.del_err_title": "Suppression impossible",
    "plan.del_err_body": "Nous n'avons pas pu supprimer votre planification. Veuillez réessayer.",
    "plan.del_retry": "Réessayer",
  },
  it: {
    "plan.del_b5": "I tuoi salvataggi di Decorazione, Cena, Tavola e Regali e il budget saranno eliminati",
    "plan.planned_title": "✨ Il tuo Natale è pianificato!",
    "plan.edit": "Modifica pianificazione",
    "plan.edit_short": "Modifica",
    "plan.save": "Salva la mia pianificazione",
    "plan.saving": "Salvataggio…",
    "plan.save_and_exit": "Salva ed esci",
    "plan.discard": "Annulla modifiche",
    "plan.keep_editing": "Continua a modificare",
    "plan.unsaved_title": "Modifiche non salvate",
    "plan.unsaved_body": "Hai apportato modifiche alla tua pianificazione che non sono ancora state salvate. Cosa vuoi fare?",
    "plan.editor_title": "Modifica pianificazione",
    "plan.editor_sub": "Tocca una tappa per completarla. Salva per aggiornare i tuoi progressi.",
    "plan.provisional": "Progresso provvisorio",
    "plan.last_update": "Ultimo aggiornamento: {when}",
    "plan.not_saved_yet": "Non hai ancora salvato la tua pianificazione.",
    "plan.open": "Apri",
    "plan.steps_done": "{done} di {total} tappe completate",
    "plan.saved_toast": "Pianificazione salvata!",
    "plan.done": "Completata",
    "plan.todo": "Da fare",
    "plan.na_mark": "Non applicabile",
    "plan.na_applicable": "Segna come applicabile",
    "plan.na_tag": "N/D",
    "cbud.title": "Budget di questa categoria",
    "cbud.sub": "Importo riservato per questa categoria, definito nel budget iniziale. Per cambiarlo, modificalo in Il Mio Budget.",
    "cbud.save": "Salva budget",
    "review.yes": "Sì",
    "review.no": "No",
    "review.ask_body": "Il tuo budget per {cat} è {old}. Stai provando a cambiarlo in {new}, cioè {delta} in più. Per mantenere il budget totale del tuo Natale, dobbiamo togliere {delta} da un'altra categoria. Cosa vuoi fare?",
    "review.act_redistribute": "Ridistribuisci {v}",
    "review.act_increase": "Aumenta il mio budget",
    "review.act_cancel": "Annulla",
    "review.q2_title": "Vuoi rivedere il tuo budget?",
    "review.q2_body": "Hai scelto di non togliere {delta} da un'altra categoria. Il budget di {cat} resta a {old}. Se vuoi spendere di più qui, puoi aumentare il budget totale del tuo Natale. Vuoi rivedere il budget totale?",
    "review.keep": "No, mantieni il mio piano",
    "review.review": "Sì, rivedi il mio budget",
    "review.total_body": "Hai provato ad aumentare {cat} da {old} a {new}. Per farlo senza ridurre le altre categorie, il budget totale dovrà aumentare di {inc}.",
    "review.current": "Budget attuale",
    "review.suggested": "Nuovo budget suggerito",
    "review.new_total_label": "Nuovo budget totale",
    "review.min_hint": "Il nuovo totale deve essere almeno {v}.",
    "review.cancel": "Annulla",
    "review.confirm_total": "Conferma nuovo budget",
    "review.total_saved": "Budget totale aggiornato",
    "review.apply_body": "Ora che il budget è aggiornato, vuoi riservare {new} per {cat}?",
    "review.apply_yes": "Sì, applica",
    "review.apply_no": "No",
    "ss.delete_group": "Elimina gruppo",
    "ss.delete_group_q": "Eliminare questo gruppo di Amico Segreto?",
    "ss.delete_group_note": "Questo rimuoverà il gruppo, i partecipanti, il sorteggio e le liste dei desideri. L'azione non può essere annullata.",
    "ss.delete_group_yes": "Sì, elimina gruppo",
    "ss.deleted": "Gruppo eliminato",
    "plan.delete": "Elimina pianificazione",
    "plan.del_title": "Eliminare la tua pianificazione?",
    "plan.del_body": "Questo cancellerà la pianificazione attuale del tuo Natale e ti permetterà di ricominciare da zero.",
    "plan.del_b1": "I tuoi progressi torneranno allo 0%",
    "plan.del_b2": "Le tappe completate verranno azzerate",
    "plan.del_b3": "Le impostazioni attuali della pianificazione verranno rimosse",
    "plan.del_b4": "Potrai creare una nuova pianificazione subito dopo",
    "plan.del_sure": "Sei sicuro di voler eliminare questa pianificazione?",
    "plan.del_note_account": "Questo non annulla il tuo account, l'accesso né l'acquisto.",
    "plan.del_ss_note": "I tuoi gruppi di Amico Segreto (con partecipanti o sorteggi) verranno conservati.",
    "plan.del_cancel": "Annulla",
    "plan.del_confirm": "Sì, elimina e ricomincia",
    "plan.del_deleting": "Eliminazione…",
    "plan.del_ok_title": "Pianificazione eliminata",
    "plan.del_ok_body": "Puoi iniziare un nuovo Natale quando vuoi. 🎄",
    "plan.del_ok_cta": "Crea il mio Natale",
    "plan.del_err_title": "Impossibile eliminare",
    "plan.del_err_body": "Non è stato possibile eliminare la tua pianificazione. Riprova.",
    "plan.del_retry": "Riprova",
  },
};
